import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDeprecatedComponentWarning } from '@nerdwallet/deprecate';
import { useIconProps } from '../useIconProps';

var Target = function Target(props) {
  useDeprecatedComponentWarning({
    component: 'Target'
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048"
  }, useIconProps(props)), /*#__PURE__*/React.createElement("path", {
    d: "M1008 896q59 0 101.5 42.5T1152 1040t-42.5 101.5T1008 1184t-101.5-42.5T864 1040t42.5-101.5T1008 896zm748 64h228v160h-228q-28 263-216.5 451.5T1088 1788v228H928v-228q-263-28-451.5-216.5T260 1120H32V960h228q28-263 216.5-451.5T928 292V64h160v228q263 28 451.5 216.5T1756 960zm-748 672q120 0 230-47t189-126 126-189 47-230-47-230-126-189-189-126-230-47-230 47-189 126-126 189-47 230 47 230 126 189 189 126 230 47z"
  }));
};

Target.displayName = 'Target';

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  Target.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    textAligned: PropTypes.bool
  };
}

export default Target;